// Madhya Pradesh election geography — 230 Vidhan Sabha seats, 29 Lok Sabha seats (ECI). District seat counts per the 230-seat map.
export const MP_FACTS = [
  { value: 230, suffix: "", label: "Vidhan Sabha seats" },
  { value: 29, suffix: "", label: "Lok Sabha seats" },
  { value: 55, suffix: "", label: "Districts" },
  { value: 5.6, suffix: "Cr+", label: "Registered voters", decimals: 1 },
];

export const MP_REGIONS = [
  {
    id: "malwa-nimar",
    name: "Malwa – Nimar",
    hindi: "मालवा–निमाड़",
    seats: 66,
    hq: "Indore (our home)",
    campaigns: 17,
    districts: [
      ["Indore", 9], ["Ujjain", 7], ["Dhar", 7], ["Khargone", 6], ["Dewas", 5], ["Ratlam", 5], ["Mandsaur", 4],
      ["Khandwa", 4], ["Barwani", 4], ["Jhabua", 3], ["Neemuch", 3], ["Shajapur", 3], ["Alirajpur", 2], ["Burhanpur", 2], ["Agar Malwa", 2],
    ],
  },
  {
    id: "madhya-bharat",
    name: "Madhya Bharat (Bhopal)",
    hindi: "मध्य भारत",
    seats: 36,
    hq: "Bhopal",
    campaigns: 8,
    districts: [["Bhopal", 7], ["Vidisha", 5], ["Rajgarh", 5], ["Betul", 5], ["Sehore", 4], ["Raisen", 4], ["Narmadapuram", 4], ["Harda", 2]],
  },
  {
    id: "mahakoshal",
    name: "Mahakoshal",
    hindi: "महाकौशल",
    seats: 38,
    hq: "Jabalpur",
    campaigns: 6,
    districts: [["Jabalpur", 8], ["Chhindwara", 7], ["Balaghat", 6], ["Katni", 4], ["Narsinghpur", 4], ["Seoni", 4], ["Mandla", 3], ["Dindori", 2]],
  },
  {
    id: "gwalior-chambal",
    name: "Gwalior – Chambal",
    hindi: "ग्वालियर–चंबल",
    seats: 34,
    hq: "Gwalior",
    campaigns: 5,
    districts: [["Gwalior", 6], ["Morena", 6], ["Bhind", 5], ["Shivpuri", 5], ["Guna", 4], ["Ashoknagar", 3], ["Datia", 3], ["Sheopur", 2]],
  },
  {
    id: "vindhya",
    name: "Vindhya",
    hindi: "विंध्य",
    seats: 30,
    hq: "Rewa",
    campaigns: 4,
    districts: [["Rewa", 8], ["Satna", 7], ["Sidhi", 4], ["Singrauli", 3], ["Shahdol", 3], ["Anuppur", 3], ["Umaria", 2]],
  },
  {
    id: "bundelkhand",
    name: "Bundelkhand",
    hindi: "बुंदेलखंड",
    seats: 26,
    hq: "Sagar",
    campaigns: 4,
    districts: [["Sagar", 8], ["Chhatarpur", 6], ["Damoh", 4], ["Tikamgarh", 3], ["Panna", 3], ["Niwari", 2]],
  },
];

// Winning graph — campaigns handled vs won, by year
export const WIN_GRAPH = [
  { year: "2019", campaigns: 3, won: 2 },
  { year: "2020", campaigns: 5, won: 4 },
  { year: "2021", campaigns: 6, won: 5 },
  { year: "2022", campaigns: 9, won: 7 },
  { year: "2023", campaigns: 12, won: 10 },
  { year: "2024", campaigns: 10, won: 9 },
  { year: "2025", campaigns: 7, won: 6 },
];

export const WIN_TOTALS = WIN_GRAPH.reduce(
  (a, r) => ({ campaigns: a.campaigns + r.campaigns, won: a.won + r.won }),
  { campaigns: 0, won: 0 }
);
export const WIN_RATE = Math.round((WIN_TOTALS.won / WIN_TOTALS.campaigns) * 100);
